import { PrivacyScreen } from '@capacitor/privacy-screen';

export const useCapacitorPrivacyScreen = () => {
  const enable = async () => {
    await PrivacyScreen.enable({
      android: {
        dimBackground: true,
        privacyModeOnActivityHidden: 'splash'
      },
      ios: {
        blurEffect: 'none'
      }
    });
  };

  const disable = async () => {
    await PrivacyScreen.disable();
  };

  return { enable, disable };
};
